import {Component, OnInit, Inject, DestroyRef, inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { ConsumerCategory } from '@emm/core/models/consumer-category.model';
import {TagService} from '@emm/core/services/tag.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'emm-add-consumer-category-dialog',
    styleUrls: ['./add-consumer-category-dialog.component.scss'],
    templateUrl: './add-consumer-category-dialog.component.html',
    standalone: false
})
export class AddConsumerCategoryDialogComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<AddConsumerCategoryDialogComponent>,
        public tagService: TagService,
        public managementApiService: ManagementApiService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit(): void {
        this.dialogRef.updatePosition({ top: '100px' });
        this.buildForm();
    }

    closeAfterSubmit(): void {
        const result = {
                id: this.form.controls.id.value,
                name: this.form.controls.name.value,
                description: this.form.controls.description.value
            } as ConsumerCategory;
        this.dialogRef.close(result);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    buildForm(): void {
        this.form = new FormGroup({
            id: new FormControl(''),
            name: new FormControl(''),
            description: new FormControl('')
        });
    }

    findTagExists(): void {
        // FIX BELOW - getConsumerTags() will need to be changed to new call for Category instead of Consumer as seen below.
        if (this.form.controls.id.valid) {
            this.tagService
                .getConsumerTags(this.form.get('id').value)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(res => {
                    if (res) {
                        this.form.controls.id.setErrors({ tagExists: true });
                    }
                });
        }
    }

    OnSubmit(): void {
        if (this.form.valid) {
            this.closeAfterSubmit();
        }
    }

}
